export default __webpack_public_path__ + "static/cd-presentation_kz-67b6e310452185a426c3f16e1f766dcf.png";